import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Website} from "../../website";
import {DragulaService} from "ng2-dragula";
import {filter, first, switchMap} from "rxjs/operators";
import {EcommerceService} from "../ecommerce.service";
import {ActivatedRoute, Router} from "@angular/router";
import * as fromStore from "../../../../store";
import {Store} from "@ngrx/store";
import {UserSubscription} from "../../../../user/user-subscription";
import {combineLatest} from "rxjs";
import {Utils} from "../../../../shared/utils/utils";
import {NotifierComponent} from "../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../shared/components/notifier/notification-type";
import {clientRoles} from "../../../../user/user-roles-actions";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import {Location} from "@angular/common";

@Component({
    selector: 'db-ecommerce-payment-methods',
    templateUrl: './payment-methods.component.html',
    styleUrls: ['./payment-methods.component.scss'],
    standalone: false
})
export class EcommercePaymentMethodsComponent implements OnInit, OnDestroy {

  @Input() website: Website;
  public pageLoading: boolean = true;
  public loading: boolean;
  public btnLoading: boolean;
  public paymentsOrder: any[];
  public paymentsMappedOrder: any[] = [];
  public demoUser: boolean;
  public setupTenWebPayments: boolean;
  public noOrdersFields: boolean;
  public disabledButton: boolean = true;
  public currentSubscription: UserSubscription;
  public userRole: any;
  public currentWorkspaceId: number;
  public clientRoles: any = clientRoles;
  public userLocalStorage: any;

  constructor(
    private _location: Location,
    private _router: Router,
    private _dragulaService: DragulaService,
    private _activatedRoute: ActivatedRoute,
    private _ecommerceService: EcommerceService,
    private readonly _googleAnalyticsService: GoogleAnalyticsService,
    private readonly _store: Store<fromStore.DbStoreState>,
  ) {

    try {
      this._dragulaService.createGroup("paymentsOrder", {
        // options
      });
      this._dragulaService.find('paymentsOrder')
        .drake
        .on('drop', (el, target, source, sibling) => {
          // Initialize an empty array to hold the IDs of the elements in their new order
          let newOrder = [];

          // Iterate over the child elements of the container (target)
          Array.from(target.children).forEach(function (element) {
            // Push the ID of each element into the newOrder array
            newOrder.push(element.id);
          });
          /*this.paymentsMappedOrder?.length && this._addTenWebPaymentsToList();*/
          this.paymentsMappedOrder = this._ordering(this.paymentsMappedOrder, newOrder);
          this.updateOrdering();
          this.disabledButton = false;
        });
    } catch (err) {
      console.log('errrr', err);
    }

    this._store.select(fromStore.getWorkspaceIdEntities).subscribe(workspaceIdEntities => {
      this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || workspaceIdEntities.ownerWorkspaceId;
    });
  }

  ngOnInit() {
    this.website = this._activatedRoute.snapshot.parent.parent.data['website'];
    this._getUserSubscription();
    !this.demoUser && this._paymentMethods();
    const queryParamsIndex: number = this._router.url.indexOf('?');
    if (queryParamsIndex !== -1) {
      this._location.replaceState(this._router.url.substring(0, queryParamsIndex));
    }
  }


  ngOnDestroy() {
    // clean up the dragula group to prevent memory leaks
    this._dragulaService.destroy("paymentsOrder");
  }


  private _paymentMethods(): void {
    this._store.select(fromStore.getEcommercePaymentMethodsLoaded(this.website?.id))
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getEcommerceAllPaymentMethods(this.website?.id))
        ))
      )
      .subscribe(([paymentAllMethods]) => {
        this._setValues(paymentAllMethods);
        this.pageLoading = false;
        const payment_methods = paymentAllMethods?.filter(method => method.enabled)?.map(method => method.id);
        this.sendGaEvent('Ecommerce - Payment Methods', 'direct_to_bq', '10Web Payments',  {payment_methods});
      });
  }


  private _setValues(paymentAllMethods): void {
    const hasNegativeOrderNumber = paymentAllMethods.find(paymentMethod => paymentMethod?.order < 0);
    this.noOrdersFields = paymentAllMethods.every(paymentMethod => paymentMethod?.order === "") || !!hasNegativeOrderNumber;
    this.paymentsOrder = paymentAllMethods;
    !!this.paymentsOrder?.length && this._mapPaymentMethods(!!this.noOrdersFields);
  }


  private _ordering(oldOrder, newOrder): any {
    // Sort paymentsMappedOrder based on the order defined in newOrder
    oldOrder.sort((a, b) => {
      const indexA = newOrder.indexOf(a.id);
      const indexB = newOrder.indexOf(b.id);
      return indexA - indexB;
    });
    // Update the position of each element to match its new index
    oldOrder.forEach((item, index) => {
      item.position = index;
    });
    return oldOrder;
  }

  private _mapPaymentMethods(noOrderNumbers: boolean): void {
    let counter = 0; // Initialize a counter
    this.paymentsMappedOrder = this.paymentsOrder.map(({id, order, enabled}) => ({
      id,
      position: order === '' ? counter++ : order,
      enabled
    }));
  }


  // Function to reorder the array putting the element with a specific ID first

  private _getUserSubscription(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserSubscription),
          this._store.select(fromStore.getUserLocalStorage)
        ))
      )
      .subscribe(([user, userSubscription, userLocalStorage]) => {
        this.demoUser = Utils.isDemoUser(userSubscription, user);
        this.userLocalStorage = userLocalStorage;
        if (this.userLocalStorage[`my_site_is_not_prohibited_confirmation${this.website?.id}`] === '1') {
          localStorage.setItem(`my_site_is_not_prohibited_confirmation${this.website?.id}`, '1');
        }
        this.userRole = user?.workspaces && user.workspaces.find(el => el.workspaceId === this.currentWorkspaceId).roleId;
      });
  }


  public updateOrdering(): void {
    this.loading = true;

    this._ecommerceService.updatePaymentListing(this.website.id, this.paymentsMappedOrder)
      .pipe(
        filter(response => !!response),
        first()
      ).subscribe((response) => {
      this.loading = false;
      this.btnLoading = false;
      if (response.success) {
        this._store.dispatch(new fromStore.LoadEcommercePaymentMethods({websiteId: this.website?.id}));
        NotifierComponent.notify(new Notification('Successfully saved', NotificationType.SUCCESS));
      } else {
        NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
      }
    });
  }

  public updateBatchStatus(batchName, status): void {
    this.disabledButton = false;
    this.paymentsMappedOrder.find(el => el.id === batchName).enabled = status;
    this.updateOrdering();
  }



  public sendGaEvent(action, eventCategory = 'Dashboard Action', eventLabel = '10Web Payments', tenwebParams = null): void {
    const analyticsData = {
      eventCategory,
      eventAction: action,
      eventLabel,
      websiteId: this.website?.id
    };

    if (tenwebParams) {
      analyticsData['tenwebParams'] = tenwebParams;
    }
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }


}

